import {Component, ChangeDetectionStrategy} from '@angular/core';
import packageJson from '../../../../package.json';
import {environment} from "@environments/environment";

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class FooterComponent {

  protected version() {
    let version = packageJson.version;
    if (environment.name != 'prod') {
      version += '@' + environment.name;
    }
    return version;
  }
}
